import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { TraceLine } from './TraceLine.js';
import style from './Exception.css';
export var Exception = /*#__PURE__*/function (_Component) {
  _inherits(Exception, _Component);

  var _super = _createSuper(Exception);

  function Exception() {
    var _this;

    _classCallCheck(this, Exception);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });

    return _this;
  }

  _createClass(Exception, [{
    key: "render",
    value: function render() {
      var expanded = this.state.expanded || this.props.expanded;
      return /*#__PURE__*/React.createElement("span", {
        className: [style.exceptionRow, this.props.isPrevious ? style.previous : 'icon-caret-dark'].join(' '),
        onClick: this.clickHandler
      }, /*#__PURE__*/React.createElement("span", {
        className: style.exception
      }, this.props.isPrevious ? t('logreader', 'Caused by ') + ' ' : '', this.props.Exception), ":\xA0", /*#__PURE__*/React.createElement("span", {
        className: style.message
      }, this.props.Message), /*#__PURE__*/React.createElement(StackTrace, {
        trace: this.props.Trace,
        expanded: expanded
      }), expanded && this.props.Previous ? [/*#__PURE__*/React.createElement(Exception, _extends({
        expanded: true
      }, this.props.Previous, {
        isPrevious: true
      }))] : []);
    }
  }]);

  return Exception;
}(Component);

function StackTrace(_ref) {
  var trace = _ref.trace,
      expanded = _ref.expanded;

  if (expanded) {
    return /*#__PURE__*/React.createElement("ol", {
      className: style.trace,
      start: "0"
    }, trace.map(function (trace, i) {
      return /*#__PURE__*/React.createElement(TraceLine, _extends({
        key: i
      }, trace));
    }));
  } else {
    return [];
  }
}